import { useCallback, useContext } from 'react';
import { NavigateOptions } from 'react-router';
import { StepName } from '|/app/services';
import StepUrlsContext from '|/context/step-urls-context';
import useNavigateInPurchase from '|/hooks/use-navigate-in-purchase';

const useNavigateToStep = () => {
  const { stepUrlMap } = useContext(StepUrlsContext);
  const navigate = useNavigateInPurchase();

  const navigateToStep = useCallback(
    (stepName: StepName, options?: NavigateOptions, deepUrl?: string) => {
      const stepUrl = stepUrlMap[stepName] ?? '';
      const url = `${stepUrl}${deepUrl ? `/${deepUrl}` : ''}`;

      navigate(`/steps/${url}`, options);
    },
    [navigate, stepUrlMap]
  );

  return navigateToStep;
};

export default useNavigateToStep;
